import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import {
  // getCreditAvailability,
  getPaymentHeadline,
  getPaymentContent,
} from 'store/ProductDetails/selectors';
import {
  IncludeContent,
  SectionGroup,
  /* Section, */
} from 'bricks';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { PAYMENT_TAB_ID } from 'store/ProductDetails/common/constants';

import styles from './styles.pcss';
import TabRouterLayout from '../_TabLayout/index';
// import CreditWidget from './components/CreditWidget/index';

const cx = classNames.bind(styles);
const PaymentTab = ({
  headline,
  content,
  isMobile,
  // isCreditAvailable,
}) => (
  <TabRouterLayout>
    <SectionGroup>
      <div id={PAYMENT_TAB_ID}>
        <div className={cx('section', 'sectionWrap', isMobile && 'mobile')}>
          <div className={cx('sectionHeadline', isMobile && 'mobile')}>{headline}</div>
          <IncludeContent className={cx('section')} htmlContent={content} />
          {/* {isCreditAvailable ? (
            <CreditWidget />
          ) : null} */}
        </div>
      </div>
    </SectionGroup>
  </TabRouterLayout>
);

PaymentTab.propTypes = {
  headline: PropTypes.node,
  content: PropTypes.string,
  isMobile: PropTypes.bool,
  // isCreditAvailable: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  headline: getPaymentHeadline(state),
  content: getPaymentContent(state),
  isMobile: isScreenBelow800(state),
  // isCreditAvailable: getCreditAvailability(state),
});

export default connect(mapStateToProps)(PaymentTab);
